<template>
  <div>
    <b-row>
      <b-colxx xxs="12" md="6" lg="6" xl="3">
        <div class="form-group has-float-label">
          <b-input-group>
            <template v-slot:prepend>
              <b-input-group-text>
                <b-icon icon="calendar"></b-icon>
              </b-input-group-text>
            </template>
            <v-date-picker
              mode="single"
              v-model="searchValue.startDate"
              :max-date="searchValue.endDate"
              :input-props="{ class:'form-control', placeholder: '' , style : 'width:100%'}"></v-date-picker>
          </b-input-group>
          <span>시작날짜</span>
        </div>
      </b-colxx>
      <b-colxx xxs="12"  md="6" lg="6"  xl="3">
        <div class="form-group has-float-label">
          <b-input-group>
            <template v-slot:prepend>
              <b-input-group-text>
                <b-icon icon="calendar"></b-icon>
              </b-input-group-text>
            </template>
            <v-date-picker
              mode="single"
              v-model="searchValue.endDate"
              :min-date="searchValue.startDate"
              :input-props="{ class:'form-control', placeholder: '' }"></v-date-picker>
          </b-input-group>
          <span>종료날짜</span>
        </div>
      </b-colxx>
      <b-colxx xxs="12" md="4" lg="6" xl="3">
        <div class="form-group has-float-label">
          <v-select :options="searchOption" v-model="searchValue.searchKind" :reduce="item=>item.value" label="label"></v-select>
          <span>검색유형</span>
        </div>
      </b-colxx>
      <b-colxx xxs="12" md="8" xl="3">
        <b-input-group class="mb-3">
          <b-input :placeholder="searchPlaceHolder" v-model="searchValue.searchKeyword" @keyup.enter="onSearch" :maxlength="searchKeywordMax"/>
          <b-button v-show="!searchFlag" @click="onSearch" variant="outline-primary default" size="sm">
            {{$t('button.search')}}
          </b-button>
          <b-button v-show="searchFlag" @click="searchCancel" variant="outline-primary" size="sm">
            {{$t('button.search-cancel')}}
          </b-button>
        </b-input-group>
      </b-colxx>
    </b-row>
    <b-row v-if="statusCheckBoxUse">
      <b-colxx xxs="12">
        <b-form-group>
<!--          <b-form-checkbox v-model="status_check_all" :checked="true" :unchecked-value="false" style="float:left"-->
<!--                           @change="refreshStatus('all')"-->
<!--                           class="mr-3">전체-->
<!--          </b-form-checkbox>-->
<!--          <b-form-checkbox-group v-model="searchValue.status_option" :options="checked_option_status"-->
<!--                                 @change="refreshStatus('part')"></b-form-checkbox-group>-->
          <b-form-checkbox v-model="searchValue.includeCancel" :checked="true" :unchecked-value="false">취소건 포함</b-form-checkbox>
        </b-form-group>
      </b-colxx>
    </b-row>
  </div>
</template>
<script>

  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'

  export default {
    components: {
      'v-select': vSelect,
    },
    props: ['statusUseFlag' ,'setOption'],
    data() {
      return {
        searchValue: {
          searchKind: 'OrderNo',
          searchKeyword: "",
          startDate: this.$moment(new Date()).subtract('day', 14).toDate(),
          endDate: this.$moment(new Date()).add('day' , 14).toDate(),
          includeCancel : false,
          status_option: []
        },
        statusCheckBoxUse : this.statusUseFlag !== undefined ? this.statusUseFlag : true ,
        searchFlag: false,
        searchOption: this.setOption !== undefined ? this.setOption : [
          {label: '주문번호', value: 'OrderNo'},
          {label: '아이템번호' , value : 'ItemNo' } ,
          {label: '아이디', value: 'Username'},
          {label: '구매자명', value: 'BuyerName'},
          {label: '수신자명', value: 'ReceiverName'},
          {label: '구매자전화번호', value: 'BuyerPhoneNumber4'},
          {label: '수신자전화번호', value: 'ReceiverPhoneNumber4'},
        ],
        status_check_all: false,
        checked_option_status: ['결제완료', '취소신청', '취소완료', '입금대기'],
      }
    },
    computed: {
      searchPlaceHolder :{
        get : function(){
          if( this.searchValue.searchKind == "BuyerPhoneNumber4" || this.searchValue.searchKind == "ReceiverPhoneNumber4" ) {
            return '뒷번호 4자리를 입력하세요'
          } else {
            return '검색어를 입력하세요'
          }
        }
      },
      searchKeywordMax : {
        get : function(){
          if( this.searchValue.searchKind == "BuyerPhoneNumber4" || this.searchValue.searchKind == "ReceiverPhoneNumber4" ) {
            return 4;
          } else {
            return 30;
          }
        }
      }
    },
    mounted() {
    },
    methods: {
      onSearch() {
        if (this.searchValue.startDate === null  ) {
          alert('검색 날짜를 확인해주세요.');
          return false
        } else if ( this.searchValue.endDate === null) {
          alert('검색 날짜를 확인해주세요.');
          return false
        }
        this.searchFlag = true
        this.$emit('search', this.searchValue)
      },
      searchCancel() {
        this.searchFlag = false
        this.searchValue.searchKeyword = ""
        this.$emit('search' , this.searchValue)
      },
      refreshStatus(e) {
        setTimeout(() => {
            if (e === 'all') this.searchValue.status_option = this.status_check_all ? this.checked_option_status : []
            else if (e === 'part') this.status_check_all = (this.checked_option_status.length === this.searchValue.status_option.length) ? true : false
          }, 50)
      },
    }
    , watch: {
      "searchValue.searchKind" : function() {
        this.searchValue.searchKeyword = ""

      },

      "searchValue.includeCancel": function(){
        this.$emit('includeCancel' , this.searchValue.includeCancel)
      }

    }
  }
</script>
